






















import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  data: (vm: ButtonSwitch) => ({
    inputIsActive: vm.isActive,
  }),
})
export default class ButtonSwitch extends Vue {
  @Model("change", { default: false }) public isActive!: boolean;
  @Prop({ default: false }) public isDisabled!: boolean;
  private inputIsActive: boolean;

  get model() {
    return this.inputIsActive;
  }

  set model(value: boolean) {
    this.inputIsActive = value;
    this.$emit("change", value);
  }

  @Watch("isActive")
  public onIsActiveChanged(isActive: boolean) {
    this.inputIsActive = isActive;
  }

  public toggle() {
    if (this.isDisabled) {
      return;
    }

    this.model = !this.model;
  }
}
